module.exports = __webpack_public_path__ + "img/paladin.017a9954.png";